<template>
  <div class="fixed w-full bg-gray-100 text-black z-10">
    <nav class="container mx-auto p-4 flex justify-between items-center">
      <h1 class="text-3xl font-bold text-blue-900">Tragefer</h1>

      <div class="lg:flex space-x-14 text-base mt-3 hidden">
        <div class="flex flex-col space-y-2">
          <a href="#">Accueil</a>
          <hr class="border border-blue-500 text-shadow-pop-tl">
        </div>
        <div class="flex flex-col space-y-2">
          <a href="#">À propos</a>
          <hr class="border border-blue-500 text-shadow-pop-tl invisible">
        </div>
        <div class="flex flex-col space-y-2">
          <a href="#">Services</a>
          <hr class="border border-blue-500 text-shadow-pop-tl invisible">
        </div>
        <div class="flex flex-col space-y-2">
          <a href="#">Projets</a>
          <hr class="border border-blue-500 text-shadow-pop-tl invisible">
        </div>
        <div class="flex flex-col space-y-2">
          <a href="#">Réferences</a>
          <hr class="border border-blue-500 text-shadow-pop-tl invisible">
        </div>
      </div>

      <button :class="hasScrolled ? 'bg-yellow-500 text-white' : 'bg-yellow-500 text-white'" class="hidden lg:block hover:bg-blue-500 hover:text-white px-3 py-2 2xl:py-2 2xl:px-4 text-sm border border-white hover:border-transparent rounded">Contactez-nous</button>

      <!-- On small screens -->
      <div class="block lg:hidden">
        <button @click="toggle" class="flex items-center px-3 py-2 border rounded text-teal-lighter border-teal-light hover:text-white hover:border-white">
          <svg class="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Menu</title><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/></svg>
        </button>
      </div>
    </nav>

    <div class="min-h-screen bg-black bg-opacity-90 flex flex-col items-center justify-center space-y-4 py-2 text-white text-base lg:hidden slide-left"
         :class="open ? 'block' : 'hidden'">
        <div class="group flex flex-col space-y-2">
          <a href="#" class="group-hover:text-gray-100">Accueil</a>
          <hr class="border border-blue-500 hidden text-shadow-pop-tl group-hover:block">
        </div>
        <div class="group flex flex-col space-y-2">
          <a href="#" class="group-hover:text-gray-100">Nos services</a>
          <hr class="border border-blue-500 hidden text-shadow-pop-tl group-hover:block">
        </div>
        <div class="group flex flex-col space-y-2">
          <a href="#" class="group-hover:text-gray-100">Projets</a>
          <hr class="border border-blue-500 hidden text-shadow-pop-tl group-hover:block">
        </div>
        <div class="group flex flex-col space-y-2">
          <a href="#" class="group-hover:text-gray-100">À propos</a>
          <hr class="border border-blue-500 hidden text-shadow-pop-tl group-hover:block">
        </div>
        <div class="group flex flex-col space-y-2">
          <a href="#" class="group-hover:text-gray-100">Réferences</a>
          <hr class="border border-blue-500 hidden text-shadow-pop-tl group-hover:block">
        </div>
        <div>
          <button class="bg-transparent bg-yellow-500 text-sm text-white py-2 px-4 rounded">Contactez-nous</button>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Navbar',
  data(){
    return {
      open : false,
      hasScrolled: false
    }
  },
  methods:{
    toggle(){
      this.open = !this.open
    },
    scrollListener() {
      this.hasScrolled = window.scrollY > 100
    }
  }
}
</script>

<style scoped>
/* ----------------------------------------------
 * Generated by Animista on 2021-9-15 15:51:7
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

@keyframes slide-left{0%{transform:translateX(100px)}100%{transform:translateX(0px)}}

.slide-left{animation:slide-left .5s cubic-bezier(.25,.46,.45,.94) both}

</style>